module.exports = {"441803102":"太和镇","441803104":"太平镇","441803105":"山塘镇","441803106":"三坑镇","441803112":"龙颈镇","441803113":"禾云镇","441803117":"浸潭镇","441803118":"石潭镇","441803450":"笔架林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441803.json
// module id = 1873
// module chunks = 0